import {Component, OnInit, ViewChild, Optional, ViewContainerRef} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {Observable} from 'rxjs/Observable';
import {ModulesService} from '../../_services/modules.service';

@Component({
    selector: 'app-modules-functions',
    templateUrl: './modules-functions.component.html',
    styleUrls: ['./modules-functions.component.css']
})
export class ModulesFunctionsComponent implements OnInit {

    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};
    modulesAlls: Observable<any[]>;
    moduleId: string;

    constructor(private modulesService: ModulesService) {
    }

    ngOnInit() {
        this.modulesAlls = this.modulesService.getModules();
        this.registerTable();
        if ($('.content-wrapper').height() < 838) {
            $('.content-wrapper').css('min-height', 838);
        }
    }

    registerTable() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                self.modulesAlls.subscribe(dataModules => {
                    parameters["search"]["modules"] = self.moduleId || dataModules[0].id;
                    //assign parameters object
                    self.parameters = parameters;
                    //assign callback object
                    self.callback = callback;

                    self.modulesService.getsModulesFunctions(parameters).subscribe(result => {
                        callback({
                            draw: parameters['draw'],
                            data: result.data,
                            recordsTotal: result.data.length,
                            recordsFiltered: result.recordsTotal
                        });
                    });
                });
            },
            columns: [
                {
                    title: "ID",
                    data: "id",
                    name: "id",
                    className: "tall text-justify"
                },
                {
                    title: "モジュール機能",
                    data: "module_function_name",
                    name: 'module_function_name',
                    className: "text-justify"
                },
                {
                    title: "",
                    data: "btn_is_active_module",
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;
                $('.btn-is-active', row).bind('click', () => {
                    self.IsAdminApprovedModules(data);
                });

                if (data['is_active_module'] == 0) {
                    $(row).css('background-color', '#3c8dbc');
                    var btn_active_bot = $(row).find('td').find('.btn-active-module');
                    btn_active_bot.css({
                        'background-color': 'HotPink',
                        'border-color': 'HotPink'
                    });
                    btn_active_bot.mouseover(function () {
                        btn_active_bot.css('opacity', '0.8');
                    });
                    btn_active_bot.mouseout(function () {
                        btn_active_bot.css('opacity', '1');
                    });
                }

                return row;
            }
        };
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page
        this.modulesService.getsModulesFunctions(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    IsAdminApprovedModules(data) {
        this.modulesService.updateIsModulesFunctions(data).subscribe(data => {
            if (!data.error) {
                this.loadCurrentPage();
            } else {
                alert(data.message);
            }
        }, error => {
            alert(error.json().message);
        });
    }

    onChangeModules(event) {
        this.moduleId = event.target.value;
        this.rerenderDataTable();
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/modules-functions/modules-functions.component.ts